// extracted by mini-css-extract-plugin
module.exports = {"modal-width":"70vw","modal":"AMPModal_modal__rCL3W"};